/**
 * stl-search.js - one card per style in the search panel (slice 6).
 *
 * The theme's predictive search asks /search/suggest for products, and on this store a style is
 * up to five products (one per colour), so "wrap" returns the same top five times. The mock shows
 * one card per style. Every card snippets/stl-card.liquid renders carries data-stl-style, so the
 * second and later cards of a style are marked data-stl-dupe and hidden by the panel's own CSS.
 * Nothing is removed from the DOM: the theme's keyboard navigation walks its own ref list, and a
 * removed node would break it.
 *
 * The panel replaces #predictive-search-results on every keystroke, so this watches the form for
 * new nodes rather than running once.
 */
const SKIN = '.stl-search-skin';

function dedupe(root) {
  const cards = root.querySelectorAll('.predictive-search-results__card');
  if (!cards.length) return;
  const seen = new Set();
  cards.forEach((card) => {
    const el = card.querySelector('[data-stl-style]');
    const key = el && el.getAttribute('data-stl-style');
    if (!key) {
      card.removeAttribute('data-stl-dupe');
      return;
    }
    if (seen.has(key)) card.setAttribute('data-stl-dupe', '');
    else {
      seen.add(key);
      card.removeAttribute('data-stl-dupe');
    }
  });
}

function watch(panel) {
  if (panel.dataset.stlSearchWatched) return;
  panel.dataset.stlSearchWatched = '1';
  dedupe(panel);
  const observer = new MutationObserver(() => dedupe(panel));
  observer.observe(panel, { childList: true, subtree: true });
}

function start() {
  document.querySelectorAll(SKIN).forEach(watch);
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
else start();
